module.exports = __webpack_public_path__ + "assets/img/3.a11ce25c.svg";